<template>
  <div class="users-filter-root">
    <div class="text-input">
      <input
        v-model="searchValue"
        @change="searchUsers"
        type="text"
        placeholder="Pretraga korisnika po imenu i/ili prezimenu"
      />
      <img class="user-search-icon" src="../../assets/icons/user-search.png" />
      <img
        v-if="searchValue"
        @click="clearSearchField"
        class="close-icon"
        src="../../assets/icons/close.png"
      />
    </div>
    <div class="users-root">
      <user-avatar
        v-for="user in filteredUsers"
        :key="user.UserId"
        :user="user"
        :isActive="selectedUser === user.UserId"
        :isUserManagment="isUserManagment"
        @userClicked="setSelectedUser"
        @deletePolaznik="onPolaznikDelete"
      ></user-avatar>
    </div>
    <div v-if="showActions" class="users-filter-actions">
      <div class="v-btn primary" @click="onFilterClicked">Filtriraj</div>
      <div class="v-btn" @click="onResetClicked">Resetiraj</div>
    </div>
  </div>
</template>
<script>
import UserAvatar from "./UserAvatar.vue";

export default {
  components: { UserAvatar },
  props: ["profesorId", "showActions", "isUserManagment"],
  data() {
    return {
      searchValue: "",
      filteredUsers: [],
      originalUserList: [],
      selectedUser: null,
    };
  },
  methods: {
    clearSearchField() {
      this.searchValue = "";
    },
    setSelectedUser(selectedUser) {
      this.selectedUser = selectedUser;
      this.$emit("onPolaznikSelected", this.selectedUser);
    },
    searchUsers(searchValue) {
      if (!searchValue) {
        this.filteredUsers = this.originalUserList;
      } else {
        this.filteredUsers = this.originalUserList.filter((x) =>
          x.Name.toLowerCase().includes(searchValue.toLowerCase())
        );
      }
    },
    onFilterClicked() {
      this.$emit("onFilterClicked");
    },
    onResetClicked() {
      this.selectedUser = null;
      this.$emit("onResetClicked");
    },
    onPolaznikDelete(polaznikId) {
      this.$emit(
        "polaznikDelete",
        this.originalUserList.find((x) => x.UserId === polaznikId)
      );
    },
    // API calls
    getStudentsByProfessor() {
      this.$store.state.services.userService
        .getStudentsByProfessor(this.$props.profesorId)
        .then((response) => {
          this.filteredUsers = response.data;
          this.originalUserList = response.data;
        });
    },
  },
  watch: {
    searchValue(value) {
      this.searchUsers(value);
    },
  },
  created() {
    this.getStudentsByProfessor();
  },
};
</script>

<style scoped>
.users-filter-root {
  position: relative;
  padding: 20px;
  height: 100%;
}
.text-input {
  position: absolute;
  left: 20px;
  top: 20px;
  right: 20px;
}
.text-input input {
  width: 100%;
  height: 35px;
  background-color: #f6f6f6;
  border-radius: 2px;
  padding-left: 30px;
  padding-right: 30px;
}
.text-input .user-search-icon {
  position: absolute;
  left: 5px;
  top: 50%;
  transform: translateY(-50%);
}

.text-input .close-icon {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}
.users-root {
  margin-top: 40px;
  height: calc(100% - 40px);
  overflow-y: auto;
}
.users-filter-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>